import * as React from 'react';
import { WatchlistItem } from 'watchlist';
import { Trans } from '../Trans';
import { MailtoButton } from './MailtoButton';
import { OnItemRemove, WatchlistItemView } from './WatchlistItemView';

interface WatchlistProps {
    items: WatchlistItem[]
    onClickRemove: OnItemRemove
}

export class WatchlistView extends React.Component<WatchlistProps> {
    public render() {
        const items = this.props.items;

        return <div className="pf-wl-view container">
            <header>
                <h1><Trans>Watchlist</Trans></h1>
            </header>
            <div className="pf-wl-result">
                <Trans arguments={[items.length]}
                       id="display_d_watchlist_items">Display {items.length} watchlist items</Trans>:
            </div>
            <table className="pf-table pf-wl-list pf-table-children">
                <tbody>
                {
                    items.map(i => <WatchlistItemView
                        key={i.guid}
                        onClickRemove={this.props.onClickRemove}
                        item={i}/>)
                }
                </tbody>
            </table>

            <div className="pf-wl-send-group">
                <MailtoButton subject={'watchlist.send_as_email.subject'} items={items}>
                    <Trans id="watchlist.send_as_email">Send as email</Trans>
                </MailtoButton>
                <MailtoButton subject={'watchlist.send_to_fms.subject'}
                              items={items}
                              recipient={'info@fms-technology.com'}>
                    <Trans id="watchlist.send_to_fms">Send to FMS</Trans>
                </MailtoButton>
            </div>
        </div>;
    }
}
